import "./FormComponents.css";
import React, { useState,useEffect,useRef } from "react";
import  rightArrow from "../../assets/arrow-right.svg";
import  leftArrow from "../../assets/arrow-left.svg";
import submittedIcon from "../../assets/submittedIcon.svg";
import dropdownArrow from "../../assets/dropdown-icon.svg";
import config from "../../config";

export const FormButtons = ({ children }) => {
  return <div className="buttons-wrapper">{children}</div>;
};

export const CancelButton = ({ name, onClick }) => {
  return (
    <button className="cancel-button" onClick={onClick}>
      <span>{name}</span>
      <img src={leftArrow} alt="right-arrow"></img>
    </button>
  );
};

export const SubmitButton = ({ name, boolVar = true, onClick }) => {
  return (
    <button
      className="submit-button"
      onClick={onClick}
      style={{
        cursor: boolVar ? "pointer" : "not-allowed",
        background: boolVar ? "#573CFF" : "#573CFF",
        transform: boolVar ? "" : "none",
        boxShadow: boolVar ? "" : "none",
      }}
    >
      <span>{name}</span>
      <img src={rightArrow} alt="right-arrow"></img>
    </button>
  );
};

export default function FormHeading(props) {
  return (
    <div className="form-heading">
      <h3> {props.h3} </h3>
      <p> {props.p} </p>
    </div>
  );
}

export const ProgressBar = ({ progress = 0 }) => {
  return (
    <div
      className="progress-bar-container"
      style={{ background: progress ? "#eee" : "#fff" }}
    >
      <div className="progress-bar" style={{ width: `${progress}%` }} />
    </div>
  );
}

export const InputBox = ({ handleInputAnswer }) =>{
  const [inputData, setInputData] = useState("");
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setInputData(e.target.value);
    setError(false);
  };
  const handleSubmit = () => {
    if (!inputData) {
      setError(true);
    } else handleInputAnswer(inputData);
  };
  return (
    <div className="input-box">
      <input
        type="text"
        value={inputData}
        autoComplete="off"
        onChange={handleChange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSubmit(e); // Call handleSubmit if Enter key is pressed
          }
        }}
      />

      <button className="send-button" onClick={handleSubmit}>
        <span> Submit </span>
      </button>
      {error && (
        <span className="error-message" style={{ left: 0 }}>
          Please enter a specific value
        </span>
      )}
    </div>
  );
}

export const ScheduledInfo=({
  dateSelected,
  timeSelected,
  timeZoneSelected,
  children,
}) => {
  const formatDate = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "long" });
    const weekday = date.toLocaleString("en-GB", { weekday: "short" });

    return {
      day,
      month,
      weekday,
    };
  };

  const { day, month, weekday } = formatDate(dateSelected);

  return (
    <div className="scheduled-for">
      {children}
      <div className="scheduled-date-time">
        <div className="scheduled-date">
          <h1 className="date-day">{day}</h1>
          <div className="month-weekday-wrapper">
            <h4 className="date-month">{month}</h4>
            <p className="date-weekday">{weekday}</p>
          </div>
        </div>
        <div className="scheduled-time">
          <div className="time-label">
            <span>Time</span>
          </div>
          <p className="time-details">
            {timeSelected} ({timeZoneSelected})
          </p>
        </div>
      </div>
    </div>
  );
}

export const SubmittedBox=({
  setStep,
  dateSelected,
  timeSelected,
  timeZoneSelected,
}) =>{
  return (
    <div className="submitted-box-overlay">
      <div className="submitted-box">
        <ScheduledInfo
          dateSelected={dateSelected}
          timeSelected={timeSelected}
          timeZoneSelected={timeZoneSelected}
        >
          <img src={submittedIcon} alt="Check Icon" />
        </ScheduledInfo>
        <div className="submitted-message">
          <h2>Demo Successfully Scheduled!</h2>
          <p>
            Our demo has been successfully booked. We look forward to showcasing
            how Xenonstack AI can transform your business.
          </p>
          <a href={config.info.REACT_APP_WEBSITE_URL}>
            <button className="done-button">
              <span>Done</span>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export const TimeZoneDropdown=({
  setTimeZoneSelected,
  timeAvalilability,
}) =>{
  const [isOpen, setIsOpen] = useState(false);
  const [timeZone, setTimeZone] = useState("GMT+05:30");
  const timezones = [
    "GMT-11:00",
    "GMT-10:00",
    "GMT-09:00",
    "GMT-08:00",
    "GMT-07:00",
    "GMT-06:00",
    "GMT-05:00",
    "GMT-04:00",
    "GMT-03:00",
    "GMT-02:00",
    "GMT-01:00",
    "GMT±00:00",
    "GMT+01:00",
    "GMT+02:00",
    "GMT+03:00",
    "GMT+04:00",
    "GMT+05:00",
    "GMT+05:30",
  ];
  const dropdownRef = useRef(null);
  const toggleDropdown = () => {
    if (!timeAvalilability) {
      alert("Select a time slot");
      return;
    }
    setIsOpen(!isOpen);
  };

  const handleTimeZoneClick = (timezone) => {
    const timeZonePicked = timezone;
    setTimeZone(timeZonePicked);
    setTimeZoneSelected(timeZonePicked);

    toggleDropdown();
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, []);
  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        <span>{timeZone}</span>
        <img src={dropdownArrow} alt="Dropdown Arrow" />
      </div>
      {isOpen && (
        <div className="dropdown-menu">
          {timezones.map((timezone, index) => (
            <div
              key={index}
              className="dropdown-item"
              onClick={() => handleTimeZoneClick(timezone)}
            >
              <p>{timezone}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export const PickTime=({
  setTimeSelected,
  setTimeZoneSelected,
  setDurationSelected,
  selectedDate,
}) =>{
  const [timeSlot, setTimeSlot] = useState(null);
  const [duration, setDuration] = useState(0);
  const slots = timeSlots[duration];
  const timeSlotsRef = useRef(null);
  // ADDED: Utility function to parse time string and get time in milliseconds
  const parseTime = (timeStr) => {
    const [startTime] = timeStr.split(" - ");
    const [hour, minute, period] = startTime.split(/[:\s]/);

    let hours = parseInt(hour, 10);
    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;

    return new Date().setHours(hours, parseInt(minute, 10), 0, 0);
  };

  // ADDED: Function to check if a time slot should be disabled
  const isSlotDisabled = (slotTime) => {
    const now = new Date();
    if (isSelectedDateToday()) return parseTime(slotTime) < now.getTime();
    else if (isWeekend()) return true;
    else return false;
  };

  const isSelectedDateToday = () => {
    const today = new Date();
    return (
      selectedDate &&
      today.getFullYear() === selectedDate.getFullYear() &&
      today.getMonth() === selectedDate.getMonth() &&
      today.getDate() === selectedDate.getDate()
    );
  };
  const isWeekend = () => {
    const date = selectedDate;
    const day = date.getDay(); // 0 for Sunday, 6 for Saturday
    return day === 0 || day === 6;
  };
  const hasAvailableSlots = () => {
    if (!isSelectedDateToday() && !isWeekend()) return slots.length > 0;
    else return slots.some((slot) => !isSlotDisabled(slot));
  };
  useEffect(() => {
    const hasAvailableSlot = hasAvailableSlots();
    if (hasAvailableSlot) {
      let slotIndex = -1;
      const firstAvailableIndex = slots.findIndex(
        (slot) => !isSlotDisabled(slot)
      );
      if (isSelectedDateToday()) {
        slotIndex = firstAvailableIndex;
      } else {
        slotIndex = 0;
      }
      if (timeSlot === null && slotIndex !== -1) {
        if (isWeekend()) return;
        setTimeSelected(slots[slotIndex]);
        setTimeSlot(slotIndex + 1);
        setTimeZoneSelected("GMT+05:30");
      } else if (timeSlot !== null) {
        setTimeZoneSelected("GMT+05:30");
        setTimeSelected(slots[slotIndex]);
        setTimeSlot(slotIndex + 1);
      } else {
        console.log("78");

        setTimeSelected(
          slots[timeSlot - 1] || "No available time slots for the date selected"
        );
      }
    } else {
      setTimeZoneSelected("");
      setTimeSelected("No available time slots for the date selected");
    } // eslint-disable-next-line
  }, [duration, selectedDate]);

  useEffect(() => {
    if (timeSlotsRef.current) {
      const firstAvailableIndex = slots.findIndex(
        (slot) => !isSlotDisabled(slot)
      );
      if (firstAvailableIndex !== -1) {
        const firstAvailableElement =
          timeSlotsRef.current.children[firstAvailableIndex];
        if (firstAvailableElement) {
          firstAvailableElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
      }
    } // eslint-disable-next-line
  }, [duration, selectedDate]);
  const handleClick = (e, index) => {
    if (isSelectedDateToday() && isSlotDisabled(e.target.innerText)) {
      return;
    }
    if (isWeekend()) return;
    const newTimeSlot = e.target.innerText;
    setTimeSlot(index);
    setTimeSelected(newTimeSlot);
  };

  const handleDuration = (e, index) => {
    setDuration(index);
    setDurationSelected(e.target.innerText);
  };

  return (
    <div className="pick-time-wrapper">
      <div className="pick-time-header">
        <h2>Pick a time</h2>
      </div>
      <TimeZoneDropdown
        timeAvalilability={hasAvailableSlots()}
        setTimeZoneSelected={(timeZone) => {
          setTimeZoneSelected(timeZone);
        }}
      />
      <div className="time-duration-tab">
        <div
          onClick={(e) => handleDuration(e, 0)}
          className={`${duration === 0 ? "active" : ""}`}
        >
          <p>15min</p>
        </div>
        <div
          onClick={(e) => handleDuration(e, 1)}
          className={`${duration === 1 ? "active" : ""}`}
        >
          <p>30min</p>
        </div>
      </div>
      <div className="time-slots" ref={timeSlotsRef}>
        {slots.map((slot, index) => {
          // Determine if slot should be disabled
          const isDisabled = isSlotDisabled(slot) ? "time-slot-disabled" : "";

          return (
            <div
              key={index}
              onClick={(e) => handleClick(e, index + 1)}
              className={`time-slot ${
                timeSlot === index + 1 ? "time-slot-picked" : ""
              } ${isDisabled}`}
              style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
            >
              <p>{slot}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

//optionlist of every question
export const IndustryList = [
  { value: "Aerospace", label: "Aerospace" },
  { value: "Agriculture", label: "Agriculture" },
  { value: "Automotive", label: "Automotive" },
  {
    value: "Banking and Finance Sector",
    label: "Banking and Finance Sector",
  },
  { value: "Consumer Goods", label: "Consumer Goods" },
  { value: "Consumer Technology", label: "Consumer Technology" },
  { value: "Education", label: "Education" },
  { value: "Enterprise Technology", label: "Enterprise Technology" },
  { value: "Financial Services", label: "Financial Services" },
  { value: "Gaming", label: "Gaming" },
  { value: "Government", label: "Government" },
  { value: "Healthcare", label: "Healthcare" },
  { value: "Hospitality", label: "Hospitality" },
  { value: "Insurance", label: "Insurance" },
  { value: "Life Sciences", label: "Life Sciences" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Marketing & Advertising", label: "Marketing & Advertising" },
  { value: "Media", label: "Media" },
  { value: "Mining", label: "Mining" },
  { value: "Non-Profit Organization", label: "Non-Profit Organization" },
  { value: "Oil and Gas", label: "Oil and Gas" },
  { value: "Power & Utilities", label: "Power & Utilities" },
  { value: "Professional Services", label: "Professional Services" },
  {
    value: "Real Estate and Construction",
    label: "Real Estate and Construction",
  },
  { value: "Retail", label: "Retail" },
  { value: "Telecommunication", label: "Telecommunication" },
  {
    value: "Transportation and Logistics",
    label: "Transportation and Logistics",
  },
  { value: "Travel", label: "Travel" },
  {
    value: "Wholesale and Distribution",
    label: "Wholesale and Distribution",
  },
  { value: "Other", label: "Other" },
];

export const jobTitles = [
  { value: "Business Owner/Leader", label: "Business Owner/Leader" },
  {
    value: "C-Suite (CEO, CTO, COO, CFO, CIO)",
    label: "C-Suite (CEO, CTO, COO, CFO, CIO)",
  },
  { value: "Vice-President", label: "Vice-President" },
  { value: "Director", label: "Director" },
  { value: "Program Manager", label: "Program Manager" },
  { value: "Head of Function", label: "Head of Function" },
  { value: "Subject Matter Expert", label: "Subject Matter Expert" },
  { value: "Senior Consultant/Engineer", label: "Senior Consultant/Engineer" },
  { value: "Other", label: "Other" },
];

export const countries = [
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Albania", label: "Albania" },
  { value: "Algeria", label: "Algeria" },
  { value: "Andorra", label: "Andorra" },
  { value: "Angola", label: "Angola" },
  { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
  { value: "Argentina", label: "Argentina" },
  { value: "Armenia", label: "Armenia" },
  { value: "Australia", label: "Australia" },
  { value: "Austria", label: "Austria" },
  { value: "Azerbaijan", label: "Azerbaijan" },
  { value: "Bahamas", label: "Bahamas" },
  { value: "Bahrain", label: "Bahrain" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Barbados", label: "Barbados" },
  { value: "Belarus", label: "Belarus" },
  { value: "Belgium", label: "Belgium" },
  { value: "Belize", label: "Belize" },
  { value: "Benin", label: "Benin" },
  { value: "Bhutan", label: "Bhutan" },
  { value: "Bolivia", label: "Bolivia" },
  { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
  { value: "Botswana", label: "Botswana" },
  { value: "Brazil", label: "Brazil" },
  { value: "Brunei", label: "Brunei" },
  { value: "Bulgaria", label: "Bulgaria" },
  { value: "Burkina Faso", label: "Burkina Faso" },
  { value: "Burundi", label: "Burundi" },
  { value: "Cabo Verde", label: "Cabo Verde" },
  { value: "Cambodia", label: "Cambodia" },
  { value: "Cameroon", label: "Cameroon" },
  { value: "Canada", label: "Canada" },
  { value: "Central African Republic", label: "Central African Republic" },
  { value: "Chad", label: "Chad" },
  { value: "Chile", label: "Chile" },
  { value: "China", label: "China" },
  { value: "Colombia", label: "Colombia" },
  { value: "Comoros", label: "Comoros" },
  { value: "Congo", label: "Congo" },
  { value: "Costa Rica", label: "Costa Rica" },
  { value: "Croatia", label: "Croatia" },
  { value: "Cuba", label: "Cuba" },
  { value: "Cyprus", label: "Cyprus" },
  { value: "Czech Republic", label: "Czech Republic" },
  { value: "Denmark", label: "Denmark" },
  { value: "Djibouti", label: "Djibouti" },
  { value: "Dominica", label: "Dominica" },
  { value: "Dominican Republic", label: "Dominican Republic" },
  { value: "Ecuador", label: "Ecuador" },
  { value: "Egypt", label: "Egypt" },
  { value: "El Salvador", label: "El Salvador" },
  { value: "Equatorial Guinea", label: "Equatorial Guinea" },
  { value: "Eritrea", label: "Eritrea" },
  { value: "Estonia", label: "Estonia" },
  { value: "Eswatini", label: "Eswatini" },
  { value: "Ethiopia", label: "Ethiopia" },
  { value: "Fiji", label: "Fiji" },
  { value: "Finland", label: "Finland" },
  { value: "France", label: "France" },
  { value: "Gabon", label: "Gabon" },
  { value: "Gambia", label: "Gambia" },
  { value: "Georgia", label: "Georgia" },
  { value: "Germany", label: "Germany" },
  { value: "Ghana", label: "Ghana" },
  { value: "Greece", label: "Greece" },
  { value: "Grenada", label: "Grenada" },
  { value: "Guatemala", label: "Guatemala" },
  { value: "Guinea", label: "Guinea" },
  { value: "Guinea-Bissau", label: "Guinea-Bissau" },
  { value: "Guyana", label: "Guyana" },
  { value: "Haiti", label: "Haiti" },
  { value: "Honduras", label: "Honduras" },
  { value: "Hungary", label: "Hungary" },
  { value: "Iceland", label: "Iceland" },
  { value: "India", label: "India" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Iran", label: "Iran" },
  { value: "Iraq", label: "Iraq" },
  { value: "Ireland", label: "Ireland" },
  { value: "Israel", label: "Israel" },
  { value: "Italy", label: "Italy" },
  { value: "Jamaica", label: "Jamaica" },
  { value: "Japan", label: "Japan" },
  { value: "Jordan", label: "Jordan" },
  { value: "Kazakhstan", label: "Kazakhstan" },
  { value: "Kenya", label: "Kenya" },
  { value: "Kiribati", label: "Kiribati" },
  { value: "North Korea", label: "North Korea" },
  { value: "South Korea", label: "South Korea" },
  { value: "Kosovo", label: "Kosovo" },
  { value: "Kuwait", label: "Kuwait" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan" },
  { value: "Laos", label: "Laos" },
  { value: "Latvia", label: "Latvia" },
  { value: "Lebanon", label: "Lebanon" },
  { value: "Lesotho", label: "Lesotho" },
  { value: "Liberia", label: "Liberia" },
  { value: "Libya", label: "Libya" },
  { value: "Liechtenstein", label: "Liechtenstein" },
  { value: "Lithuania", label: "Lithuania" },
  { value: "Luxembourg", label: "Luxembourg" },
  { value: "Madagascar", label: "Madagascar" },
  { value: "Malawi", label: "Malawi" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Maldives", label: "Maldives" },
  { value: "Mali", label: "Mali" },
  { value: "Malta", label: "Malta" },
  { value: "Marshall Islands", label: "Marshall Islands" },
  { value: "Mauritania", label: "Mauritania" },
  { value: "Mauritius", label: "Mauritius" },
  { value: "Mexico", label: "Mexico" },
  { value: "Micronesia", label: "Micronesia" },
  { value: "Moldova", label: "Moldova" },
  { value: "Monaco", label: "Monaco" },
  { value: "Mongolia", label: "Mongolia" },
  { value: "Montenegro", label: "Montenegro" },
  { value: "Morocco", label: "Morocco" },
  { value: "Mozambique", label: "Mozambique" },
  { value: "Myanmar", label: "Myanmar" },
  { value: "Namibia", label: "Namibia" },
  { value: "Nauru", label: "Nauru" },
  { value: "Nepal", label: "Nepal" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Nicaragua", label: "Nicaragua" },
  { value: "Niger", label: "Niger" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "North Macedonia", label: "North Macedonia" },
  { value: "Norway", label: "Norway" },
  { value: "Oman", label: "Oman" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Palau", label: "Palau" },
  { value: "Panama", label: "Panama" },
  { value: "Papua New Guinea", label: "Papua New Guinea" },
  { value: "Paraguay", label: "Paraguay" },
  { value: "Peru", label: "Peru" },
  { value: "Philippines", label: "Philippines" },
  { value: "Poland", label: "Poland" },
  { value: "Portugal", label: "Portugal" },
  { value: "Qatar", label: "Qatar" },
  { value: "Romania", label: "Romania" },
  { value: "Russia", label: "Russia" },
  { value: "Rwanda", label: "Rwanda" },
  { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
  { value: "Saint Lucia", label: "Saint Lucia" },
  {
    value: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  { value: "Samoa", label: "Samoa" },
  { value: "San Marino", label: "San Marino" },
  { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "Senegal", label: "Senegal" },
  { value: "Serbia", label: "Serbia" },
  { value: "Seychelles", label: "Seychelles" },
  { value: "Sierra Leone", label: "Sierra Leone" },
  { value: "Singapore", label: "Singapore" },
  { value: "Slovakia", label: "Slovakia" },
  { value: "Slovenia", label: "Slovenia" },
  { value: "Solomon Islands", label: "Solomon Islands" },
  { value: "Somalia", label: "Somalia" },
  { value: "South Africa", label: "South Africa" },
  { value: "South Sudan", label: "South Sudan" },
  { value: "Spain", label: "Spain" },
  { value: "Sri Lanka", label: "Sri Lanka" },
  { value: "Sudan", label: "Sudan" },
  { value: "Suriname", label: "Suriname" },
  { value: "Sweden", label: "Sweden" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Syria", label: "Syria" },
  { value: "Taiwan", label: "Taiwan" },
  { value: "Tajikistan", label: "Tajikistan" },
  { value: "Tanzania", label: "Tanzania" },
  { value: "Thailand", label: "Thailand" },
  { value: "Timor-Leste", label: "Timor-Leste" },
  { value: "Togo", label: "Togo" },
  { value: "Tonga", label: "Tonga" },
  { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
  { value: "Tunisia", label: "Tunisia" },
  { value: "Turkey", label: "Turkey" },
  { value: "Turkmenistan", label: "Turkmenistan" },
  { value: "Tuvalu", label: "Tuvalu" },
  { value: "Uganda", label: "Uganda" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "United States", label: "United States" },
  { value: "Uruguay", label: "Uruguay" },
  { value: "Uzbekistan", label: "Uzbekistan" },
  { value: "Vanuatu", label: "Vanuatu" },
  { value: "Vatican City", label: "Vatican City" },
  { value: "Venezuela", label: "Venezuela" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Yemen", label: "Yemen" },
  { value: "Zambia", label: "Zambia" },
  { value: "Zimbabwe", label: "Zimbabwe" },
];

export const questionsList = [
  {
    question: "Which industry best describes your organization?",
    answers: [
      "Aerospace & Defense",
      "Agriculture & AgriTech",
      "Automotive & Transportation",
      "Banking & Financial Services",
      "Consumer Goods & Retail",
      "Education & EdTech",
      "Healthcare & Life Sciences",
      "Hospitality & Travel",
      "Insurance",
      "Manufacturing & Industrial Automation",
      "Media & Entertainment",
      "Public Sector & Government",
      "Real Estate & Construction",
      "Telecommunication",
      "Utilities & Energy",
      "Wholesale & Distribution",
      "Other (Please specify)",
    ],
  },
  {
    question:
      "What segment best categorizes your organization?",
    answers: [
      "Startup",
      "Scale-up",
      "Small and Medium Enterprises (SME)",
      "Mid-Sized Enterprises",
      "Large Enterprises",
      "Public Sector/Government",
      "Non-Profit Organization",
    ],
  },
  {
    question:
      "Where is your organization in its journey with Vision AI and Edge AI?",
    answers: [
      "Conceptualized: Use cases identified, awaiting Proof of Concept (PoC)",
      "PoC Completed: Ready for next-stage deployment",
      "In Production with Challenges: Operational but with current limitations",
      "Not Yet Defined: Exploring Vision AI and Edge AI potential",
    ],
  },
  {
    question:
      "Select your primary focus area(s) for Vision AI and Edge AI applications:",
    answers: [
      "Surveillance and Security Monitoring", 
      "Real-Time Video Analytics",
      "Quality Control and Inspection", 
      "Predictive Maintenance", 
      "Autonomous Vehicles & Robotics",
      "Customer Behavior & Interaction Analysis",
      "Inventory & Resource Management",
      "Process Automation",
      "Other (Please specify)",
    ],
  },
  {
    question:
      "How does your organization currently generate insights from visual data?",
    answers: [
      "Traditional Camera Surveillance",
      "Basic Video Analytics",
      "Edge AI & IoT Solutions",
      "Cloud-Based Video Analytics Platforms",
      "Other (Please specify)",
    ],
  },
  {
    question: "What data sources would you need to integrate with Computer Vision Solution?",
    answers: [
      "On-prem Video Feeds",
      "Cloud Storage Solutions (e.g., AWS, Azure)",
      "IoT/Edge Devices",
      "Other (Please specify)",
    ],
  },
  {
    question:
      "What does success with computer vision look like for your organization?",
    answers: [
      "Enhanced real-time monitoring and insights",
      "Improved accuracy and efficiency in visual data processing",
      "Greater operational scalability and automation",
      "Enhanced customer or employee experiences",
      "Other (Please specify)",
    ],
  },
];

export const timeSlots = [
  [
    "9:00 AM - 9:15 AM",
    "9:15 AM - 9:30 AM",
    "9:30 AM - 9:45 AM",
    "9:45 AM - 10:00 AM",
    "10:00 AM - 10:15 AM",
    "10:15 AM - 10:30 AM",
    "10:30 AM - 10:45 AM",
    "10:45 AM - 11:00 AM",
    "11:00 AM - 11:15 AM",
    "11:15 AM - 11:30 AM",
    "11:30 AM - 11:45 AM",
    "11:45 AM - 12:00 PM",
    "12:00 PM - 12:15 PM",
    "12:15 PM - 12:30 PM",
    "12:30 PM - 12:45 PM",
    "12:45 PM - 1:00 PM",
    "1:00 PM - 1:15 PM",
    "1:15 PM - 1:30 PM",
    "1:30 PM - 1:45 PM",
    "1:45 PM - 2:00 PM",
    "2:00 PM - 2:15 PM",
    "2:15 PM - 2:30 PM",
    "2:30 PM - 2:45 PM",
    "2:45 PM - 3:00 PM",
    "3:00 PM - 3:15 PM",
    "3:15 PM - 3:30 PM",
    "3:30 PM - 3:45 PM",
    "3:45 PM - 4:00 PM",
    "4:00 PM - 4:15 PM",
    "4:15 PM - 4:30 PM",
    "4:30 PM - 4:45 PM",
    "4:45 PM - 5:00 PM",
    "5:00 PM - 5:15 PM",
    "5:15 PM - 5:30 PM",
    "5:30 PM - 5:45 PM",
    "5:45 PM - 6:00 PM",
    "6:00 PM - 6:15 PM",
    "6:15 PM - 6:30 PM",
    "6:30 PM - 6:45 PM",
    "6:45 PM - 7:00 PM",
    "7:00 PM - 7:15 PM",
    "7:15 PM - 7:30 PM",
    "7:30 PM - 7:45 PM",
    "7:45 PM - 8:00 PM",
    "8:00 PM - 8:15 PM",
    "8:15 PM - 8:30 PM",
    "8:30 PM - 8:45 PM",
    "8:45 PM - 9:00 PM",
    "9:00 PM - 9:15 PM",
    "9:15 PM - 9:30 PM",
    "9:30 PM - 9:45 PM",
    "9:45 PM - 10:00 PM",
  ],

  [
    "9:00 AM - 9:30 AM",
    "9:30 AM - 10:00 AM",
    "10:00 AM - 10:30 AM",
    "10:30 AM - 11:00 AM",
    "11:00 AM - 11:30 AM",
    "11:30 AM - 12:00 PM",
    "12:00 PM - 12:30 PM",
    "12:30 PM - 1:00 PM",
    "1:00 PM - 1:30 PM",
    "1:30 PM - 2:00 PM",
    "2:00 PM - 2:30 PM",
    "2:30 PM - 3:00 PM",
    "3:00 PM - 3:30 PM",
    "3:30 PM - 4:00 PM",
    "4:00 PM - 4:30 PM",
    "4:30 PM - 5:00 PM",
    "5:00 PM - 5:30 PM",
    "5:30 PM - 6:00 PM",
    "6:00 PM - 6:30 PM",
    "6:30 PM - 7:00 PM",
    "7:00 PM - 7:30 PM",
    "7:30 PM - 8:00 PM",
    "8:00 PM - 8:30 PM",
    "8:30 PM - 9:00 PM",
    "9:00 PM - 9:30 PM",
    "9:30 PM - 10:00 PM",
  ],
];